import { axios } from '@/utils/request'
import { stringify } from 'qs'


/* 应用包列表 */
export function getAppPageList(data) {
  return axios({
    url: `/warestore/application-packages/page`,
    method: 'post',
    headers: {
      "Content-Type": 'application/json'
    },
    data,
  })
}

/* 应用包审核 */
export function appPackageExamine(packageId, data) {
  return axios({
    url: `/warestore/application-packages/${packageId}/examine`,
    method: 'put',
    data
  })
}

/* 应用包上下架 */
export function appPackageLaunch(packageId, data) {
  return axios({
    url: `/warestore/application-packages/${packageId}/set-launching`,
    method: 'put',
    data
  })
}

/* 批量获取应用信息 */
export function getAppInfo(ids) {
  return axios({
    url: `/bigtable/applications`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',

    },
    data: stringify({
      ids,
    })
  })
}

/* 批量下架应用包 */
export function batchTakedown(data) {
  return axios({
    url: `/warestore/application-packages/set-launching/batch`,
    method: 'put',
    data,
  })
}

/* 删除应用包 */
export function deleteAppPackage(packageId) {
  return axios({
    url: `/warestore/application-packages/${packageId}`,
    method: 'delete'
  })
}

/**
 * @params:
 * @description:获取单个应用下的数据
 */
 export function getSingleApp(appId, opts = {}) {
  const url =`/ware-engine/apps/${appId}` // 新老应用都使用ware-engine获取
  const { needGetFormId = false, isSandbox } = opts
  let { isPublish = true } = opts
  if (isSandbox) isPublish = false // 沙箱模式使用lastest
  return new Promise((resolve, reject) => {
    axios({ url, method: 'GET' }).then(async (res) => {
      if(res.code == '0' && res.data instanceof Object) {
        res = { // 兼容原接口格式
          formId: null,
          ...res.data,
          appId: res.data.id, // 兼容
        }
        if (needGetFormId && ['FORM', 'PROCESS', 'FORM_V1', 'PROCESS_V1'].includes(res.type)) {
          // 额外接口获取formId并assign
          const isV1 = res.type.includes('V1')
          try {
            const { code, data } = await getFormData(appId, { isV1, isPublish })
            if (code == 0 && data && data.id) {
              if (isPublish) {
                // 正式版（默认）
                Object.assign(res, {
                  formId: data.id,
                  definition_publish: data.script // 新老应用都顺便存表单模型
                })
              } else {
                // 沙箱
                Object.assign(res, {
                  formId: data.id,
                  definition_lastest: data.script
                })
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
      }
      resolve(res)
    }).catch((error) => reject(error))
  })
}

/* 设置推荐应用 */
export function setAppPackageRecommend(packageId, toRecommend) {
  return axios({
    url: `/warestore/application-packages/${packageId}/recommend`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data: stringify({
      toRecommend,
    })
  })
}

export const applicationApi = {
  getAppPageList,
  appPackageExamine,
  appPackageLaunch,
  getAppInfo,
  deleteAppPackage,
  batchTakedown,
  getSingleApp,
  setAppPackageRecommend
}